angular.module('filters').filter('membershipPlanJoiningFeeFilter', ["$rootScope", "$filter", function($rootScope, $filter) {
  return function(costUpfront, currency) {
    var symbol;
    if (costUpfront > 0) {
      symbol = currency || $rootScope.gym.currency_symbol;
      return $filter('currency')(costUpfront, symbol);
    } else {
      return "No initial payment";
    }
  };
}]);
